var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'button',
    ("button--" + _vm.styleClass),
    (_vm.modificator) ? ("button--" + _vm.modificator) : false
  ],attrs:{"type":_vm.typeAttr,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }